/**
 * Calculates the absolute position of a result in the search results.
 *
 * @param {number} positionOnPage - The relative position of the item on the current page (starting at 1).
 * @param {number} page - The current page number (starting at 0).
 * @param {number} hitsPerPage - The number of results displayed per page.
 * @returns {Array} - The absolute position of the item.
 */
export function calculateHitPosition(positionOnPage, page, hitsPerPage) {
  if (positionOnPage < 1) {
    throw new Error('positionOnPage must be greater than or equal to 1')
  }
  if (page < 0 || hitsPerPage <= 0) {
    throw new Error('Page number must be >= 0 and hitsPerPage must be > 0')
  }

  return [positionOnPage + page * hitsPerPage]
}

/**
 * Finds the $positionOnPage for an objectID in the search results.
 *
 * @param {Array} hits - Array of search result items.
 * @param {string} objectID - The objectID of the target item.
 * @returns {number|null} - The $positionOnPage (1-based), or null if not found.
 */
export function getPositionOnPage(hits, objectID) {
  const index = hits.findIndex(hit => hit.objectID === objectID)
  return index !== -1 ? index + 1 : null // Add 1 because positions are 1-based
}
